<section class="checklist-home-page-container" *ngIf="!isLoadingLabels && !isFirstLoadingChecklistTable">
	<header>
		<h1>{{ labels.lbl_checklist }}</h1>

		<div class="under-title">
			<nav class="navigation">
				<a [routerLink]="'/checklist'">< {{ labels['lbl_checklist'] }}</a>
			</nav>
			<div class="button-container">
				<cpi-search-input [labels]="labels" [tags]="searchTags" (getSearch)="searchChecklist($event.tag, $event.text)">
				</cpi-search-input>
				<a [routerLink]="'/checklist/map'"
					><button>
						<span>_MAP</span><span><fa-icon [icon]="icons.faArrowUpRightFromSquare"></fa-icon></span></button
				></a>
				<a [routerLink]="'/checklist/new'"
					><button>
						<span>{{ labels['lbl_novo_checklist'] }}</span
						><span><fa-icon [icon]="icons.faArrowUpRightFromSquare"></fa-icon></span></button
				></a>
			</div>
		</div>
	</header>
	<main>
		<div class="checklist-table-container" *ngIf="checklistTableArr?.length > 0">
			<div class="table-line header">
				<div>ID</div>
				<div>{{ labels['lbl_geral_nome'] }}</div>
				<div>{{ labels['lbl_bul_acoes_descricao'] }}</div>
				<div>{{ labels['lbl_geral_cadastrado_por'] }}</div>
				<div>{{ labels['lbl_geral_status'] }}</div>
				<div>{{ labels['lbl_bulletin_actions'] }}</div>
			</div>
			<a class="table-line" [routerLink]="'/checklist/execute/' + checklist.id" *ngFor="let checklist of checklistTableArr">
				<div [ngClass]="{ marquee: isElementOverflown(idEl) }" [title]="checklist.id" #idEl>
					<span>{{ checklist.id }}</span>
				</div>
				<div [ngClass]="{ marquee: isElementOverflown(nameEl) }" [title]="checklist.name" #nameEl>
					<span>{{ checklist.name }}</span>
				</div>
				<div [ngClass]="{ marquee: isElementOverflown(descriptionEl) }" [title]="checklist.description" #descriptionEl>
					<span>{{ checklist.description }}</span>
				</div>
				<div [ngClass]="{ marquee: isElementOverflown(registeredByEl) }" [title]="checklist.registered_by" #registeredByEl>
					<span>{{ checklist.registered_by }}</span>
				</div>
				<div [ngClass]="{ marquee: isElementOverflown(statusEl) }" [title]="checklist.status" #statusEl>
					<span>{{ checklist.status }}</span>
				</div>
				<div class="action-cell" (click)="stopPropagation($event)">
					<a [href]="'/checklist/edit/' + checklist.id"><fa-icon [icon]="icons.faPencil"></fa-icon></a>
					<a [href]="'/checklist/execute/' + checklist.id"><fa-icon [icon]="icons.faSquareCheck"></fa-icon></a>
				</div>
			</a>
		</div>

		<div class="no-checklist" *ngIf="checklistTableArr.length == 0">
			<span>{{ labels['lbl_nenhum_checklist_registrado_executar'] }}</span>
			<span><fa-icon [icon]="icons.faCoffee"></fa-icon></span>
		</div>

		<div class="fog-container" *ngIf="isLoadingChecklistTable">
			<div class="loading-container">
				<cpi-svg-gears></cpi-svg-gears>
				<div>{{ labels.lbl_edocs_carregando }}!</div>
			</div>
		</div>
	</main>
</section>

<div class="loading-container" *ngIf="isLoadingLabels || isFirstLoadingChecklistTable || isLoadingLabels">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
